/**
 * Template List Component
 * Mostra la lista dei template con azioni
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

const TemplateList = ({ 
  templates, 
  loading, 
  onSend, 
  onPreview, 
  onDelete,
  onRefresh 
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!templates || templates.length === 0) {
    return (
      <div className="empty-state">
        <div className="icon">📝</div>
        <h3>{t('templates.empty.title')}</h3>
        <p>{t('templates.empty.description')}</p>
      </div>
    );
  }

  const getStatusClass = (status) => {
    switch (status?.toUpperCase()) {
      case 'APPROVED': return 'approved';
      case 'PENDING': return 'pending';
      case 'REJECTED': return 'rejected';
      default: return '';
    }
  };

  const formatCategory = (category) => {
    switch (category) {
      case 'UTILITY': return '🔧 Utility';
      case 'MARKETING': return '📢 Marketing';
      case 'AUTHENTICATION': return '🔐 Auth';
      default: return category;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="template-list">
      {/* Header */}
      <div className="template-list-header">
        <span>{t('templates.list.name')}</span>
        <span>{t('templates.list.category')}</span>
        <span>{t('templates.list.status')}</span>
        <span>{t('templates.list.created')}</span>
        <span>{t('templates.list.actions')}</span>
      </div>

      {/* Items */}
      {templates.map((template) => (
        <div key={template.id} className="template-item">
          <div className="template-name">
            {template.name}
            <span>{template.language.toUpperCase()}</span>
          </div>
          
          <div className="category-badge">
            {formatCategory(template.category)}
          </div>
          
          <div>
            <span className={`status-badge ${getStatusClass(template.status)}`}>
              {t(`templates.status.${template.status?.toLowerCase()}`)}
            </span>
          </div>
          
          <div className="template-date">
            {formatDate(template.created_at)}
          </div>
          
          <div className="template-actions">
            <button 
              className="btn-send"
              onClick={() => onSend(template)}
              disabled={template.status !== 'APPROVED'}
              title={template.status !== 'APPROVED' ? t('templates.sendDisabled') : t('templates.send')}
            >
              📤
            </button>
            <button 
              className="btn-preview"
              onClick={() => onPreview(template)}
              title={t('templates.preview')}
            >
              👁️
            </button>
            <button 
              className="btn-delete"
              onClick={() => onDelete(template.id)}
              title={t('templates.delete')}
            >
              🗑️
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TemplateList;
